import { userHasAttendanceKioskLogin } from "../../realm/settingsPermissions";

/** Standard staff/member session — short inactivity warning. */
export const DEFAULT_INACTIVITY_MS = 10 * 60 * 1000;

/** Kiosk + admin sessions stay active for a full training day. */
export const EXTENDED_SESSION_MS = 10 * 60 * 60 * 1000;

const NORMAL_SESSION_POLICY = {
  extended: false,
  inactivityTimeoutMs: DEFAULT_INACTIVITY_MS,
};

/**
 * Admin accounts and explicit attendance-kiosk permission get extended sessions.
 * Other accounts keep the default short inactivity timeout and JWT-based logout.
 */
export function resolveSessionPolicy(userInfo) {
  const user = userInfo?.[0];
  if (!user) return NORMAL_SESSION_POLICY;

  const extended =
    user.isAdmin === true || userHasAttendanceKioskLogin(userInfo);

  if (!extended) return NORMAL_SESSION_POLICY;

  return {
    extended: true,
    inactivityTimeoutMs: EXTENDED_SESSION_MS,
  };
}

export function resolveAutoLogoutMs(session, policy, loginTimestampMs = null) {
  if (policy?.extended) {
    const loginTs = Number(loginTimestampMs);
    const base =
      Number.isFinite(loginTs) && loginTs > 0 ? loginTs : Date.now();
    const remaining = base + EXTENDED_SESSION_MS - Date.now();
    return remaining > 0 ? remaining : 0;
  }

  if (session?.expires_at) {
    const remaining = session.expires_at * 1000 - Date.now();
    return remaining > 0 ? remaining : 0;
  }

  return null;
}
